import ApiService from '../api.services';

const DriversService = {
  list: async function () {
    try {
      const response = await ApiService.get('/api/users/type/4');
      return response.data.records;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (form) {
    try {
      const data = {
        driver: form,
      };
      data.driver.role = '41edb754-d3dd-4b05-8e09-cec2a26ea65b';
      data.driver.type = '4';
      const res = await ApiService.post('/api/users', data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, form) {
    const data = {
      driver: form,
    };
    data.driver.type = '4';
    try {
      const response = await ApiService.put(`/api/users/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default DriversService;

export { DriversService };

